import React, { useMemo } from "react"
import { useAppSelector } from "@/store"
import { selectLoginState } from "@/stores/login_slice"
import { Flex, Image, Text } from "@chakra-ui/react"
import defaultAvatar from "@/assest/default_avatar.png"

// 个人账户登录组件
export const PCLoginView: React.FC = () => {
  const { currentUser, msg } = useAppSelector(selectLoginState)

  // 头像
  const avatarSrc = useMemo(
    () => currentUser?.avatar || defaultAvatar,
    [currentUser]
  )
  return (
    <Flex direction="column" width="100vw" height="100vh" alignItems="center">
      {/* 用户头像 */}
      <Image
        src={avatarSrc}
        alt="avatar"
        width="88px"
        height="88px"
        marginTop="26vh"
        marginBottom="16px"
      />

      {/* 用户昵称 */}
      <Text fontSize="15px" color="white">
        {currentUser?.nickName
          ? `尊敬的用户：${currentUser?.nickName}，欢迎使用金山云桌面～`
          : ""}
      </Text>

      {/* 登录状态提醒 */}
      <Text
        margin="0px auto"
        fontSize="13px"
        textColor="white"
        marginTop={"16px"}
      >
        {msg}
      </Text>
    </Flex>
  )
}
